import { getIsCurrentUserAuthenticated, getMemberById } from '../members/members-selectors';
import { getLanguage } from '../base-params/base-params-selectors';
import { showToast } from '../comments/effects/show-toast-action';
export const FOLLOW_MEMBER_REQUEST = 'FOLLOW_MEMBER_REQUEST';
export const FOLLOW_MEMBER_FAILURE = 'FOLLOW_MEMBER_FAILURE';
export const FOLLOW_MEMBER_SUCCESS = 'FOLLOW_MEMBER_SUCCESS';
export const UNFOLLOW_MEMBER_REQUEST = 'UNFOLLOW_MEMBER_REQUEST';
export const UNFOLLOW_MEMBER_FAILURE = 'UNFOLLOW_MEMBER_FAILURE';
export const UNFOLLOW_MEMBER_SUCCESS = 'UNFOLLOW_MEMBER_SUCCESS';
export const followMemberRequest = (payload) => ({
    type: FOLLOW_MEMBER_REQUEST,
    payload,
});
export const followMemberFailure = (payload) => ({
    type: FOLLOW_MEMBER_FAILURE,
    payload,
});
export const followMemberSuccess = (payload) => ({
    type: FOLLOW_MEMBER_SUCCESS,
    payload,
});
export const unfollowMemberRequest = (payload) => ({
    type: UNFOLLOW_MEMBER_REQUEST,
    payload,
});
export const unfollowMemberFailure = (payload) => ({
    type: UNFOLLOW_MEMBER_FAILURE,
    payload,
});
export const unfollowMemberSuccess = (payload) => ({
    type: UNFOLLOW_MEMBER_SUCCESS,
    payload,
});
export const followMember = ({ memberId, resourceId }) => async (dispatch, getState, { wixCodeApi, membersService, testMode }) => {
    dispatch(followMemberRequest({ memberId, resourceId }));
    const state = getState();
    if (!getIsCurrentUserAuthenticated(state)) {
        const hasLoggedIn = Boolean(await openLoginModal(wixCodeApi, state));
        if (!hasLoggedIn) {
            return dispatch(followMemberFailure({
                memberId,
                resourceId,
            }));
        }
    }
    if (testMode.followMember) {
        return dispatch(followMemberSuccess({ memberId, resourceId }));
    }
    (await membersService.followMember({ memberId })).type === 'SUCCESS'
        ? dispatch(followMemberSuccess({ memberId, resourceId }))
        : [
            followMemberFailure({
                memberId,
                resourceId,
            }),
            showToast({
                resourceId,
                skin: 'error',
                message: {
                    type: 'TRANSLATION',
                    key: 'toast.error-follow-member',
                    keyValue: {
                        memberName: getMemberName(state, memberId),
                    },
                },
            }),
        ].map(dispatch);
};
export const unfollowMember = ({ memberId, resourceId }) => async (dispatch, getState, { wixCodeApi, membersService, testMode }) => {
    dispatch(unfollowMemberRequest({ memberId, resourceId }));
    const state = getState();
    if (!getIsCurrentUserAuthenticated(state)) {
        const hasLoggedIn = Boolean(await openLoginModal(wixCodeApi, state));
        if (!hasLoggedIn) {
            return dispatch(unfollowMemberFailure({
                memberId,
                resourceId,
            }));
        }
    }
    if (testMode.followMember) {
        dispatch(unfollowMemberSuccess({ memberId, resourceId }));
    }
    (await membersService.unfollowMember({ memberId })).type === 'SUCCESS'
        ? dispatch(unfollowMemberSuccess({ memberId, resourceId }))
        : (() => {
            dispatch(unfollowMemberFailure({
                memberId,
                resourceId,
            }));
            dispatch(showToast({
                resourceId,
                skin: 'error',
                message: {
                    type: 'TRANSLATION',
                    key: 'toast.error-unfollow-member',
                    keyValue: {
                        memberName: getMemberName(state, memberId),
                    },
                },
            }));
        })();
};
const getMemberName = (state, memberid) => getMemberById(state, memberid)?.profile?.nickname ?? '';
const openLoginModal = (wixCodeApi, state) => wixCodeApi.user
    .promptLogin({
    lang: getLanguage(state),
    modal: true,
})
    .catch(() => undefined);
//# sourceMappingURL=member-follow-actions.js.map